// K-13 / #20 — içerik tipinden bağımsız çeviri-grubu varyant yüzeyi.
//
// `GET /api/v1/contents/{contentType}/groups/{groupId}/variants` grubun
// silinmemiş tüm dil varyantlarını döner; VariantPanel'in hızlı dil-atlama
// navigasyonu buradan beslenir. Yetki BE'de içerik tipine göre mevcut
// policy'lerden çözülür (content.read / taxonomy.manage) — yeni izin yok.

import { http, unwrapList, type ActionResponse } from './http';
import type { components } from '@/types/api';

export type ContentVariantType = 'article' | 'page' | 'sss' | 'campaign' | 'category';

export type ContentVariant = components['schemas']['ContentVariantDto'];

export const contentsApi = {
  /** Grubun kardeş dil varyantları (id + dil + slug + status + başlık). */
  async variants(contentType: ContentVariantType, groupId: string): Promise<ContentVariant[]> {
    const res = await http.get<ActionResponse<ContentVariant>>(
      `/api/v1/contents/${contentType}/groups/${groupId}/variants`,
    );
    return unwrapList(res).items;
  },
};
